import { Component, OnInit, Input, HostBinding, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LocationStrategy } from '@angular/common';

import { LoginService, HttpService, CssService, MainService } from 'app/resources/services/index';
import { Subject, DefineBootboxId } from 'app/resources/classes/index';
import 'bootbox';

type imagem = { arquivo: string, alt: string };
@Component({
  moduleId: module.id,
  selector: 'app-login',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  hasLogo: boolean;

  public possuiCadastroUsuario: boolean;
  private logotipo: any;
  @Input() subject: Subject = new Subject();
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public logo: String;
  public clienteMensagem: String;
  public processando: boolean;
  public getBrowser: Navigator = navigator;
  public navegadorInvalido: Boolean;
  public isRecuperarChaveAcesso: boolean;

  constructor(public mainService: MainService,
    public location: LocationStrategy,
    public router: Router) { }

  ngOnInit() {
    this.isRecuperarChaveAcesso = false;
    this.mainService.clean();
    this.mainService.loginService.possuiCadastroUsuario().subscribe(
      sucesso => {
        this.possuiCadastroUsuario = sucesso.json();
      }
    );
    // Aviso

    //    bootbox.dialog({
    //   message:
    //   `<div class='img-responsive'>
    //   <img src='assets/img/avisos/Best+Pontos_Lentidão.jpg' class="hidden-xs" alt="Transferências não realizadas">
    //   <img src='assets/img/avisos/Best+Pontos_Lentidão_Mobile.jpg' class="visible-xs" alt="Transferências não realizadas">
    //   </div>`,
    //   closeButton: true,
    //   buttons: {
    //     cancel: {
    //       label: 'Fechar',
    //       className: 'app-btn-best'
    //     }
    //   }
    // });

    this.validarBrowser();

    window.scrollTo(0, 0);
    this.processando = true;
    if (this.mainService.sessionService.sessaoExpirada) {
      this.mainService.sessionService.sessaoExpirada = false;
      this.bootboxAlertComId.alerta('Sua sessão expirou! Você deverá efetuar um novo login'
        + ' para continuar utilizando nossa plataforma.');
    }

    this.mainService.loginService.getMsgInicial().subscribe(
      sucesso => {
        this.clienteMensagem = sucesso.text().substr(1, sucesso.text().length - 2);
      }
    );

    this.mainService.http.pathApi().get(this.getLogo())
      .subscribe(data => {
        this.logotipo = data.url;
        this.processando = false;
        this.hasLogo = true;
      }, erro => {
        this.processando = false;
        this.hasLogo = false;
      });

    // this.avisoManutencao();
  }

  public validarBrowser() {

    const browserVersion = this.getBrowser.userAgent.match(/Trident[/]/);
    if (browserVersion == null) {
      this.navegadorInvalido = false;
    } else {
      this.navegadorInvalido = true;
    }

  }

  public irParaLogin(isTelaLogin: boolean) {
    this.isRecuperarChaveAcesso = !isTelaLogin;
  }

  public doLogin(event) {
    event.preventDefault();
    this.mainService.loginService.doLogin(this.subject)
      .subscribe(
        sucesso => {
          this.subject = new Subject();
        }, err => {
          this.bootboxAlertComId.alerta(err._body);
        }
      );
  }

  public requestPwd() {
    if (this.subject === undefined ||
      this.subject.principal === undefined ||
      this.subject.principal.length < 3) {
      this.bootboxAlertComId.alerta('Preencha o número da chave de acesso!');
    } else {
      this.mainService.loginService.subject = this.subject;
      this.router.navigate(['/makepwd']);
    }
  }

  public irParaRecuperarChaveDeAcesso() {
    this.isRecuperarChaveAcesso = true;
  }

  public getLogo() {
    let parametro = undefined;
    const location = (<any>this.location)._platformLocation.location;
    if (location.hostname === 'www.picpontos.com.br' || location.hostname === 'picpontos.com.br' ||
      location.hostname === 'localhost' || location.hostname === 'homolog.picpontos.com.br' || location.hostname === '127.0.0.1') {
      if (this.mainService.sessionService !== undefined && this.mainService.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.mainService.sessionService.getClientUuid();
      } else {
        parametro = '?type=context&content=' + (<any>this.location)._platformLocation.location.href.split('/')[3];
        if ((<any>this.location)._platformLocation.location.href.split('/')[3] !== '#'
          && (<any>this.location)._platformLocation.location.href.split('/')[3] !== 'login') {
          this.mainService.sessionService.isCustomized = true;
        }
      }
    } else {
      if (this.mainService.sessionService !== undefined && this.mainService.sessionService.getClientUuid()) {
        parametro = '?type=client&content=' + this.mainService.sessionService.getClientUuid();
      } else {
        parametro = '?type=domain&content=' + location.hostname;
      }
    }
    return 'clientes/logotipo/' + parametro;
  }

  public botaoDisabled() {
    if (this.subject.principal && this.subject.password) {
      return true;
    }
  }

  // AVISO DE MANUTENÇÃO
  // public avisoManutencao() {
  //   const mobile: imagem = { arquivo: '../../img/avisos/Best+Pontos_Comunicado_Manutencao_Mobile.jpg', alt: 'Comunicado Manutenção.' };
  //   this.mainService.aviso.alerta(mobile);
  // }

}



// WEBPACK FOOTER //
// ./src/app/public/login/login.component.ts